import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl'
import cx from 'classnames';
import Copy from '@/shared/ui/Copy';
import Box from '@/shared/ui/Box';
import Input from '@/shared/ui/Input';
import { IconArrowTo } from "@/shared/ui/Icons";
import { useNavigation } from "@/processes/Router";
import _get from "lodash/get";
import useCryptoCurrencies from "@/processes/PoolStats/hooks/useCryptoCurrencies";
import { useMinerAccount } from "@/processes/MinerAccounts";
import {BASE_HOST} from "@/shared/constants/env";
import { loginWithRedirect } from "@/global/utils/apiHelpers";
import s from './MinerAddress.module.scss';
import Link from "next/link";

type MinerAddressProps = {
  address: string;
  className?: string;
  children?: React.ReactNode;
}

const MinerAddress = (props: MinerAddressProps) => {
  const {
    address = '',
    className = '',
    children,
  } = props;
  const intl = useIntl();
  const { coin, isKAS, coinLower } = useNavigation();
  const { cryptoCurrencies } = useCryptoCurrencies();
  const { account } = useMinerAccount();

  const cryptoCurrency = cryptoCurrencies.find((item: any) => item.name === coin);
  const explorerUrl = _get(cryptoCurrency, 'explorer.base', '');
  const explorerWallet = _get(cryptoCurrency, 'explorer.wallet', '');

  const explorerHref = `${explorerUrl}${explorerWallet}${address}`

  return (
    <Box className={cx(className, 'relative')} size="sm" withBorder={false}>
      { !!explorerUrl.length ? <Link
        target={'_blank'}
        href={explorerHref}
        className="absolute right-[15px] z-10 text-xs text-[#FF9500] font-medium flex items-center pl-2 py-[2px]"
      >
        <FormattedMessage id="View in Explorer" />
        <IconArrowTo className="ml-1 w-4"/>
      </Link> : null }

      <Input
        label={intl.formatMessage({id: 'miner.address'})}
        labelTextClassName="text-xs ml-2"
        inputClassName={s.input}
        suffix={
          <Copy 
            title={intl.formatMessage({id: 'copy'})} 
            text={address} 
            className='-mr-2'
          />
        }
        value={address}
        readOnly={true}
        full
      />
      {children}

      {isKAS && account.length === 0 ? <div className="text-xs font-medium mt-2 ml-2 text-white">
        <FormattedMessage
          id="miner.address.singIn"
          values={{
            a: (chunks) => <Link href={loginWithRedirect(`${BASE_HOST}/${coinLower}/dashboard?miner=${address}`)} className="text-[#FF9500]">
              {chunks}
            </Link>
          }}
        />
      </div> : null}
    </Box>
  );
}

export default MinerAddress;
